import { Article } from '@hugendubel/article';
import { Button, FormButtons, PageSpinner } from '@hugendubel/react-basic';
import { _ } from '@hugendubel/utils';
import React, { useCallback, useEffect, useState } from 'react';
import { ArticleService } from '../../../services/article-service';
import { Store } from '../../../store';
import { BonusPoints } from '../../BonusPoints';
import { usePickupButtonHandler } from '../../hooks/usePickupButtonHandler';
import { RoutingUrl } from '../../appRoutes';
import { ArticleDetailsView } from './ArticleDetailsView';
import { useNavigate } from 'react-router-dom';
import { ReducedProduct } from '../../../ws/result/ReducedProduct';

type ArticleDetailsStoreProps = { points: BonusPoints };
type ArticleDetailsOwnProps = { article: ReducedProduct; close: () => Promise<void> };
export type ArticleDetailsProps = ArticleDetailsOwnProps & ArticleDetailsStoreProps;

export const UnconnectedArticleDetails: React.FC<ArticleDetailsProps> = ({ close, article, points }) => {
    const navigate = useNavigate();
    const {
        articleId,
        attributes,
        price,
        availability: { number, preorder },
    } = article;
    const BRANCH_ONLY_BONUS_ARTICLE = 210;
    const isPurchasable = price.bonusCost ? price.bonusCost <= points.value : false;
    const isBranchOnlyArticle = number === BRANCH_ONLY_BONUS_ARTICLE;
    const isPreOrder = preorder;

    const [fullArticle, setArticle] = useState<void | Article>(undefined);
    const onSubmit = useCallback(() => {
        navigate(RoutingUrl.delivery(articleId), { replace: true });
    }, [articleId, navigate]);

    useEffect(() => {
        attributes?.ean && ArticleService.loadArticleDetails(attributes.ean).then(setArticle);
    }, [attributes]);

    const pickupButtonHandler = usePickupButtonHandler(article);

    return (
        <>
            <div className="article-details">
                {fullArticle ? <ArticleDetailsView article={fullArticle} /> : <PageSpinner />}
            </div>
            {pickupButtonHandler && (
                <div className="additional-buttons">
                    <Button
                        type="button"
                        onClick={pickupButtonHandler}
                        disabled={!isPurchasable}
                        label="article.box.button.pickup"
                        className={_.classNames('btn btn-default', !isPurchasable && 'btn-disabled')}
                    />
                </div>
            )}
            <FormButtons
                onSubmit={onSubmit}
                submitLabel="article.box.button.buy"
                abortLabel="button.cancel"
                disabled={isBranchOnlyArticle || !isPurchasable || isPreOrder}
                onAbort={close}
            />
        </>
    );
};

export const ArticleDetails = Store.wire<ArticleDetailsStoreProps, ArticleDetailsOwnProps>(
    UnconnectedArticleDetails,
    ({ points }) => ({ points })
);
